import { Component, Input, inject, OnInit, ViewChild } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../layout/loader/loader.component';
import { FormsModule } from '@angular/forms';
import { ModalHeaderComponent } from '../../modals/modal-header/modal-header.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { OrderOrganisationFormComponent } from '../order-organisation-form/order-organisation-form.component';
import { OrderInvoiceFormComponent } from '../order-invoice-form/order-invoice-form.component';

@Component({
  selector: 'app-order-create',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    LoaderComponent,
    OrderOrganisationFormComponent,
    OrderInvoiceFormComponent,
    ModalHeaderComponent
  ],
  templateUrl: './order-create-form.component.html',
  styleUrl: './order-create-form.component.scss'
})
export class OrderCreateFormComponent implements OnInit {
  @ViewChild(OrderOrganisationFormComponent) organisationForm!: OrderOrganisationFormComponent;
  @ViewChild(OrderInvoiceFormComponent) invoiceForm!: OrderInvoiceFormComponent;

  @Input() reload: boolean = false;

  modalTitle: string = 'Bestelling aanmaken';
  modalStyle: boolean = false;

  errorMessage: string = '';
  loading: boolean = false;
  currentStep: number = 1;

  periods: any;

  @Input() item: any = {};

  formErrors: any = {};

  constructor(private apiService: ApiService, private activeModal: NgbActiveModal, private router: Router) { }

  ngOnInit(): void {
    if (this.item.id != undefined) {
      this.modalTitle = "Bestelling wijzigen";
    }
  }

  goToNextStep() {
    this.errorMessage = '';

    if (this.currentStep === 1) {
      if (this.validateSchoolDetails()) {
        this.currentStep = 2;
      } else {
        this.errorMessage = 'Controleer de gemarkeerde velden.';
      }
    } else if (this.currentStep === 2) {
      if (this.validateContactDetails()) {
        this.createOrder();
      } else {
        this.errorMessage = 'Controleer de gemarkeerde velden.';
      }
    }
  }

  createOrder() {
    this.loading = true;

    if (this.item.id == undefined) {
      this.apiService.post('/office/orders', this.item)
        .then((data: any) => {
          this.loading = false;
          this.activeModal.close(true);
          this.router.navigate(['/orders/details/' + data.id], {
            queryParams: { popup: 'add-products' },
            queryParamsHandling: 'merge'
          });
        })
        .catch(() => {
          this.loading = false;
          this.errorMessage = 'Fout bij het aanmaken van de bestelling.';
        });
    }
  }

  validateSchoolDetails(): boolean {
    this.formErrors = {};
    let isValid = true;
    
    if (!this.item.organisation_name) { this.formErrors.organisation_name = true; isValid = false; }
    if (!this.item.period_id) { this.formErrors.period_id = true; isValid = false; }
    if (!this.item.organisation_type) { this.formErrors.organisation_type = true; isValid = false; }
    if (!this.item.organisation_location) { this.formErrors.organisation_location = true; isValid = false; }
    if (!this.item.organisation_address) { this.formErrors.organisation_address = true; isValid = false; }
    if (!this.item.organisation_postal_code) { this.formErrors.organisation_postal_code = true; isValid = false; }
    if (!this.item.organisation_city) { this.formErrors.organisation_city = true; isValid = false; }
    if (!this.item.organisation_country) { this.formErrors.organisation_country = true; isValid = false; }
    if (!this.item.name) { this.formErrors.name = true; isValid = false; }
    if (!this.item.email) { this.formErrors.email = true; isValid = false; }

    this.organisationForm.formErrors = this.formErrors;

    return isValid;
  }

  validateContactDetails(): boolean {
    this.formErrors = {};
    let isValid = true;

    if (!this.item.invoice_email) { this.formErrors.invoice_email = true; isValid = false; }
    if (!this.item.invoice_address) { this.formErrors.invoice_address = true; isValid = false; }
    if (!this.item.invoice_postal_code) { this.formErrors.invoice_postal_code = true; isValid = false; }
    if (!this.item.invoice_city) { this.formErrors.invoice_city = true; isValid = false; }
    if (!this.item.invoice_country) { this.formErrors.invoice_country = true; isValid = false; }

    this.invoiceForm.formErrors = this.formErrors;

    return isValid;
  }

  goToPreviousStep() {
    if (this.currentStep > 1) {
      this.currentStep--;
    }
  }
}